import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { type: String }

  connect() {
    // Store the original text from Rails duration_with_seconds
    this.originalText = this.element.textContent.trim()
    this.startTime = Date.now()

    // Only start ticking if the text includes seconds (compact format with 's')
    if (this.originalText.includes('s')) {
      this.startTicking()
    }
  }

  disconnect() {
    this.stopTicking()
  }

  startTicking() {
    this.timer = setInterval(() => {
      this.updateSeconds()
    }, 1000) // Update every second
  }

  stopTicking() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  updateSeconds() {
    // Calculate how many seconds have passed since we started
    const secondsElapsed = Math.floor((Date.now() - this.startTime) / 1000)

    // Parse the compact format: "3d 1h 29m 33s" or "3h 29m 33s" or "45m 12s" or "25s"
    const timeRegex = /(?:(\d+)d\s*)?(?:(\d+)h\s*)?(?:(\d+)m\s*)?(\d+)s/
    const match = this.originalText.match(timeRegex)

    if (match) {
      const originalDays = parseInt(match[1]) || 0
      const originalHours = parseInt(match[2]) || 0
      const originalMinutes = parseInt(match[3]) || 0
      const originalSeconds = parseInt(match[4]) || 0

      // Calculate total original seconds
      const totalOriginalSeconds = (originalDays * 86400) + (originalHours * 3600) + (originalMinutes * 60) + originalSeconds

      // Determine direction: count down for "until_start" and "until_end", count up for "overdue_start" and "overdue_end"
      const isCountdown = this.typeValue === 'until_start' || this.typeValue === 'until_end'
      const newTotalSeconds = isCountdown
        ? Math.max(0, totalOriginalSeconds - secondsElapsed) // Count down, but don't go below 0
        : totalOriginalSeconds + secondsElapsed // Count up for overdue

      // Break down into days, hours, minutes, seconds
      const newDays = Math.floor(newTotalSeconds / 86400)
      const newHours = Math.floor((newTotalSeconds % 86400) / 3600)
      const newMinutes = Math.floor((newTotalSeconds % 3600) / 60)
      const newSeconds = newTotalSeconds % 60

      // Format in compact style
      let newText = ''
      if (newDays > 0) {
        newText += `${newDays}d `
      }
      if (newHours > 0) {
        newText += `${newHours}h `
      }
      if (newMinutes > 0 || newHours > 0 || newDays > 0) {
        newText += `${newMinutes}m `
      }
      newText += `${newSeconds}s`

      this.element.textContent = newText.trim()
    }
  }
}
